<template>
  <div class="settlePays">
    <div class="head-box">
      <h4>付款单列表</h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入付款单标题/付款单据号"
          v-model="searchValue"
          class="c-search"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增付款单</el-button>
        <!-- <el-dropdown class="c-m-l-10" @command="audit" v-has="'SettlePays,audit'">
          <el-button type="primary">
            审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
            <el-dropdown-item command="3">审核通过</el-dropdown-item>
            <el-dropdown-item command="4">审核不通过</el-dropdown-item>
            <el-dropdown-item command="5">反审</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="c-m-l-10" @command="audit" v-has="'SettlePays,submitAudit'">
          <el-button type="primary">
            提交审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectSettles"
          highlight-current-row
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column
            label="付款单标题"
            prop="title"
            fixed
            width="200px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="num"
            label="付款单据号"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="type"
            label="付款对象"
            width="150px"
            show-overflow-tooltip
            :formatter="formatType"
          ></el-table-column>
          <el-table-column
            prop="payMethod"
            label="付款方式"
            width="150px"
            show-overflow-tooltip
            :formatter="formatPayMethod"
          ></el-table-column>
          <el-table-column label="付款单状态" width="150px">
            <template slot-scope="scope">
              <el-tag effect="plain" v-if="scope.row.settlePayState == 0">
                {{ formatSettlePayState(scope.row.settlePayState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settlePayState == 1">
                {{ formatSettlePayState(scope.row.settlePayState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settlePayState == 2" type="success">
                {{ formatSettlePayState(scope.row.settlePayState) }}
              </el-tag>
              <el-tag
                effect="dark"
                v-else-if="scope.row.settlePayState == -1 || scope.row.settlePayState == -2"
                type="danger"
              >
                {{ formatSettlePayState(scope.row.settlePayState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settlePayState" type="info">
                {{ formatSettlePayState(scope.row.settlePayState) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="计划拨付时间" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.state1Time || '不限制' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            width="150px"
          ></el-table-column>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <template v-for="(item, i) in extFields">
            <!-- 判断是否在列表展示 -->
            <template v-if="!item.frontEndConfig.listHide">
              <!-- 关联字典表 -->
              <template v-if="item.valueOption">
                <!-- 级联 -->
                <el-table-column
                  v-if="item.type == 'cascade'"
                  :label="item.nameDisp"
                  :key="i"
                  width="150px"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ formatCascade(item.valueOption, scope.row.exts[item.name]) }}
                  </template>
                </el-table-column>
                <!-- 多选 -->
                <el-table-column
                  v-else-if="item.type == 'checkbox'"
                  :label="item.nameDisp"
                  :key="i"
                  width="150px"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ formatArray(item.valueOption, scope.row.exts[item.name]) }}
                  </template>
                </el-table-column>
                <!-- 下拉/单选 -->
                <el-table-column
                  v-else
                  :label="item.nameDisp"
                  :key="i"
                  width="120px"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ format(item.valueOption, scope.row.exts[item.name]) }}
                  </template>
                </el-table-column>
              </template>
              <!-- 非关联字典表 -->
              <template v-else>
                <el-table-column
                  :prop="'exts.' + item.name"
                  :label="item.nameDisp"
                  :key="i"
                  width="120px"
                  show-overflow-tooltip
                ></el-table-column>
              </template>
            </template>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="付款单" :visible.sync="openDetail" custom-class="c-dialog">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="付款单标题" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item
          label="付款对象"
          prop="type"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select v-model="formData.type" clearable @change="getSettles()">
            <el-option
              v-for="item in options.type"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="付款方式"
          prop="payMethod"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select v-model="formData.payMethod" clearable @change="getSettles()">
            <el-option
              v-for="item in options.payMethod"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划拨付时间">
          <el-date-picker
            v-model="formData.state1Time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
          ></el-date-picker>
        </el-form-item>
        <!-- 0 平台->服务商 -->
        <el-form-item
          label="选择伙伴"
          v-if="formData.type == 0"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请选择'
          }"
        >
          <el-select v-model="formData.toId" clearable @change="getSettles()">
            <el-option
              v-for="item in options.partners"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 1 平台->工队 -->
        <!-- 2 服务商->工队 -->
        <!-- 3 服务商->管家 -->
        <!-- 4 工队->工人 -->
        <el-form-item label="备注">
          <el-input type="textarea" :rows="1" v-model="formData.memo"></el-input>
        </el-form-item>
        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]" @change="$forceUpdate()">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
        <!-- 表格 -->
        <el-table
          ref="table2"
          height="500"
          :data="settles.fpi.data"
          v-loading="settles.loading"
          border
          stripe
          @selection-change="selectChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="结算单标题" fixed width="200px" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="$router.push({ path: `/Settle/${scope.row._id}` })"
                type="text"
              >
                {{ scope.row.title }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="结算单据号"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="type"
            label="结算对象"
            width="150px"
            show-overflow-tooltip
            :formatter="formatType"
          ></el-table-column>
          <el-table-column label="实结总金额" prop="totalAmount" width="150px"></el-table-column>
          <el-table-column label="结算开始时间" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.startTime || '不限制' }}
            </template>
          </el-table-column>
          <el-table-column label="结算结束时间" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.endTime || '不限制' }}
            </template>
          </el-table-column>
          <el-table-column label="结算单状态" width="150px">
            <template slot-scope="scope">
              <el-tag effect="plain" v-if="scope.row.settleState == 0">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settleState == 1">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settleState == 2" type="success">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settleState == 3" type="warning">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settleState == 4" type="danger">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.settleState" type="info">
                {{ formatSettleState(scope.row.settleState) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            width="150px"
          ></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <div>
          共查询到
          <span class="c_blue">{{ settles.fpi.data.length }}</span>
          条符合条件的结算单，已选择
          <span class="c_blue">{{ settles.selectedRows.length }}</span>
          条。
        </div>
        <div>
          <el-button type="primary" @click="doSave">确 定</el-button>
          <el-button @click="doInit">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'SettlePays',
  data() {
    window.$this = this;
    return {
      name: 'settlePay',
      fpi: {},
      settles: {
        fpi: {
          data: []
        },
        selectedRows: [],
        loading: false
      },
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_type: { codeId: 'settleType' },
        codecfg_payMethod: { codeId: 'payMethod' },
        codecfg_settlePayState: { codeId: 'settlePayState' },
        codecfg_settleState: { codeId: 'settleState' }
      },
      selectedRows: [] //勾选的付款单
    };
  },
  mounted() {
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'settle',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || {};
        for (var item of res.data) {
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.$util.renderExtField(this.extFields, this.formData);
        this.getPartners();
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData();
        });
      },
      { noload: true }
    );
  },
  methods: {
    formatType(row, column, cellValue) {
      return this.osg.codelabel('type', cellValue);
    },
    formatPayMethod(row, column, cellValue) {
      return this.osg.codelabel('payMethod', cellValue);
    },
    formatSettlePayState(val) {
      return this.osg.codelabel('settlePayState', val);
    },
    formatSettleState(val) {
      return this.osg.codelabel('settleState', val);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      this.settles = {
        fpi: {
          data: []
        },
        selectedRows: [],
        loading: false
      };
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:title|string#or': this.searchValue,
        'regex:num|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/settlePay/query.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.getSettles(true);
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      let params = this.$util.deepCopy(this.formData);
      params.settlePayState = params.settlePayState || 0;
      if (params.settlePayState != 0) {
        this.osg.alert('当前付款单状态不允许修改', () => {
          this.getData();
        });
        return;
      }

      if (this.osg.validate()) {
        // 勾选的结算单列表
        let settleIdList = [];
        for (var item of this.settles.selectedRows) {
          settleIdList.push(item._id);
        }
        if (settleIdList.length == 0) {
          this.osg.alert('请至少勾选一条数据!', 'warning');
          return;
        }
        params.settleIdList = settleIdList;

        this.osg.ajax('biz/settlePay/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/settlePay/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getPartners() {
      var params = {
        _all: '1',
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partners = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getSettles(edit) {
      if (!this.formData.toId) {
        return;
      }
      this.settles.loading = true;
      var params = {
        _all: '1',
        'in:settleState|array-integer#and': '2,3',
        'is:toId|string#and': this.formData.toId,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'biz/settle/query.do',
        params,
        res => {
          this.settles.fpi = res;
          this.settles.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();

            if (edit) {
              // 编辑付款单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.settleIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 指定选中结算单
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.table2.toggleRowSelection(row);
        });
        this.$forceUpdate();
      } else {
        this.$refs.table2.clearSelection();
      }
    },
    // 选中结算单行变化时触发
    selectChange(rows) {
      this.settles.selectedRows = rows;
    },
    // 列表多选
    selectSettles(rows) {
      this.selectedRows = rows;
    },
    // 审核
    audit(settlePayState) {
      /**
       * settlePayState
       * 0:待提交（服务商新建后是自由态-->状态设为0:待提交）
       * 1:待审核（服务商点提交审核-->状态改为1:待审核）
       * 2:撤回-动作（付款单状态为1未审核或4审核未通过时 服务商可以点撤回-->状态改为0:待提交）
       * 3:审核通过（平台点审核通过-->付款单状态改为2:审核通过）
       * 4:审核不通过（平台点审核通过-->付款单状态改为4:审核不通过）
       * 5:反审-动作（付款单状态为2或4已审核时 平台可以点反审-->付款单状态改为1:待审核）
       */
      // 至少选择一个付款单
      if (this.selectedRows.length == 0) {
        this.osg.toast('请至少选择一个付款单', 'warning');
        return;
      }
      // 判断选择的付款单状态是否符合审核条件
      let msg = '';
      switch (settlePayState) {
        case '1':
          for (let settle of this.selectedRows) {
            if (settle.settlePayState != '0') {
              this.osg.alert(`您选择的付款单"${settle.title}"状态 不符合"提交审核"条件`, 'warning');
              return;
            }
          }
          msg = '提交成功，待审核。';
          break;
        case '2':
          for (let settle of this.selectedRows) {
            if (settle.settlePayState != '1' && settle.settlePayState != '4') {
              this.osg.alert(`您选择的付款单"${settle.title}"状态 不符合"撤回修改"条件`);
              return;
            }
          }
          msg = '撤回成功，可修改后重新提交。';
          break;
        case '3':
          for (let settle of this.selectedRows) {
            if (settle.settlePayState != '1') {
              this.osg.alert(`您选择的付款单"${settle.title}"状态 不符合"审核"条件`);
              return;
            }
          }
          msg = '审核通过，处理完成。';
          break;
        case '4':
          for (let settle of this.selectedRows) {
            if (settle.settlePayState != '1') {
              this.osg.alert(`您选择的付款单"${settle.title}"状态 不符合"审核"条件`);
              return;
            }
          }
          msg = '审核不通过，处理完成。';
          break;
        case '5':
          for (let settle of this.selectedRows) {
            if (settle.settlePayState != '2' && settle.settlePayState != '4') {
              this.osg.alert(`您选择的付款单"${settle.title}"还未审核 不符合"反审"条件`);
              return;
            }
          }
          msg = '反审处理完成，付款单状态改为待审核。';
          break;
        default:
      }
      let settleIds = [];
      this.selectedRows.map(item => {
        settleIds.push(item._id);
      });
      this.osg.ajax(
        `/biz/settlePay/repapprove/${settlePayState}.do`,
        {
          settleIds: settleIds.join()
        },
        () => {
          this.osg.toast(msg);
          this.getData();
        }
      );
    }
  }
};
</script>
<style lang="scss">
.settlePays .c-dialog.el-dialog {
  width: 90% !important;
  height: 90% !important;
  .el-dialog__body {
    padding: 30px 20px !important;
  }
}
#app .settlePays .c-dialog.el-dialog {
  max-height: 90vh !important;
  margin: 5vh auto 5vh !important;
  margin-top: 5vh !important;
}
</style>
